export default __webpack_public_path__ + "static/media/About Us - Banner 4.afdf1609.jpg";